import { all, call, put, takeLatest } from "redux-saga/effects";
import { AxiosCall, AxiosPost, AxiosPatch, AxiosDelete } from "../../../utils/axios";
import * as actions from "./sensorManagementActions";

// ==================== SENSOR MANAGEMENT (CRUD) ====================

function* fetchSensors(action) {
    try {
        const filters = action.payload || {};
        const queryParams = new URLSearchParams();

        // Add filters to query params
        if (filters.organization) {
            queryParams.append('organization', filters.organization);
        }
        if (filters.search) {
            queryParams.append('search', filters.search);
        }
        if (filters.is_active !== undefined) {
            queryParams.append('is_active', filters.is_active);
        }

        const queryString = queryParams.toString();
        const url = `/mycore/sensors/${queryString ? `?${queryString}` : ''}`;

        const result = yield call(AxiosCall, url);
        yield put(actions.fetchSensorsSuccess(result.data));
    } catch (e) {
        yield put(actions.fetchSensorsFailure(e.message));
    }
}

function* createSensor(action) {
    try {
        const result = yield call(AxiosPost, '/mycore/sensors/', action.payload);
        yield put(actions.createSensorSuccess(result.data));
        // Refresh sensor list after creation
        yield put(actions.fetchSensorsRequest());
    } catch (e) {
        yield put(actions.createSensorFailure(e.response?.data || e.message));
    }
}

function* updateSensor(action) {
    try {
        const { id, data } = action.payload;
        const result = yield call(AxiosPatch, `/mycore/sensors/${id}/`, data);
        yield put(actions.updateSensorSuccess(result.data));
        // Refresh sensor list after update
        yield put(actions.fetchSensorsRequest());
    } catch (e) {
        yield put(actions.updateSensorFailure(e.response?.data || e.message));
    }
}

function* deleteSensor(action) {
    try {
        const id = action.payload;
        yield call(AxiosDelete, `/mycore/sensors/${id}/`);
        yield put(actions.deleteSensorSuccess(id));
    } catch (e) {
        yield put(actions.deleteSensorFailure(e.response?.data || e.message));
    }
}

function* toggleSensorActive(action) {
    try {
        const id = action.payload;
        const result = yield call(AxiosPatch, `/mycore/sensors/${id}/toggle-active/`, {});
        yield put(actions.toggleSensorActiveSuccess(result.data));
    } catch (e) {
        yield put(actions.toggleSensorActiveFailure(e.response?.data || e.message));
    }
}

function* fetchUserOrganizations() {
    try {
        const result = yield call(AxiosCall, '/mycore/sensors/user-organizations/');
        yield put(actions.fetchUserOrganizationsSuccess(result.data));
    } catch (e) {
        yield put(actions.fetchUserOrganizationsFailure(e.response?.data || e.message));
    }
}

// ==================== ROOT SAGA ====================

export default function* sensorManagementSaga() {
    yield all([
        takeLatest(actions.FETCH_SENSORS.REQUEST, fetchSensors),
        takeLatest(actions.CREATE_SENSOR.REQUEST, createSensor),
        takeLatest(actions.UPDATE_SENSOR.REQUEST, updateSensor),
        takeLatest(actions.DELETE_SENSOR.REQUEST, deleteSensor),
        takeLatest(actions.TOGGLE_SENSOR_ACTIVE.REQUEST, toggleSensorActive),
        takeLatest(actions.FETCH_USER_ORGANIZATIONS.REQUEST, fetchUserOrganizations),
    ]);
}
